export default "__VITE_ASSET__Cxxy84Z2__"